import { createContext } from 'react';
import { DEFAULT_THEME, tTheme } from './themeConfig';

export interface IColorThemeContext {
  theme: tTheme;
  switchTheme: (theme: tTheme) => void;
}

export const ColorThemeContext = createContext<IColorThemeContext>({
  theme: DEFAULT_THEME,
  switchTheme: () => undefined
});
